// @flow
import type { StatelessFunctionalComponent } from 'react';
import styled from 'styled-components';

const LoginWrapper: StatelessFunctionalComponent<*> = styled.div`
  max-width: 450px;
  text-align: center;
  margin: auto !important;
  color: #737373;
  
  a {
    display: flex;
    align-items: center;
    color: var(--blue-color);
    text-decoration: none;
  }
  
  .Login {
    
    .inputs-container {
      display: inline-block;
      width: 100%;
      max-width: 395px;
    }
    
    &-buttonsContainer {
      display: inline-flex;
      flex-direction: column;
      align-items: center;
      padding: 48px 40px 32px 40px;
      > * + * {
        margin-top: 20px;
      }
    }

    &-link {
      font-family: var(--font-family-alt);
    }
  }

  .Register {

    &-inputs {
      display: inline-block;
      width: 100%;
    }

    &-firsttitle {
      font-family: var(--font-family-alt);
    }

    &-buttonsContainer {
      display: flex;
      flex-direction: column;
      align-items: center;
      padding: 32px 140px;

      > * + * {
        margin-top: 20px;
      }
      
      @media (max-width: 536px) {
        padding: 22px 30px;
      }
    }

    &-messageContainer {
      padding: 25px 0 0;
    }

    &-link {
      font-family: var(--font-family-alt);
    }
  }

  .Message {

    &-container {
      display: flex;
      justify-content: center;
      align-items: center;
      padding: 5px 0;
    }

    &-img {
      width: 25px;
      height: 25px;
      margin-right: 10px;
    }

    &-text {
      font-size: 1.4em;
      color: var(--text-color-1);

      span {
        display: contents;
      }
    }
  }

  .Password {
    
    &-firsttitle {
      font-family: var(--font-family-alt);
    }

    &-inputs {
      display: inline-block;
      width: 100%;
      max-width: 395px;
    }

    &-input-line {
      display: flex;
    }

    &-input-img-container {
      margin: 16px 12px 12px 0px;
      width: 30px;
      height: 25px;
    }

    &-input-img {
      width: 25px;
      height: 25px;
    }

    &-image {
      width: 25px;
      height: 25px;
      margin: 16px 12px 12px 0px;
    }

    &-buttons {
      padding: 32px 100px;

      > * + * {
        margin-top: 20px;
      }

      @media (max-width: 536px) {
        padding: 22px 30px;
      }
    }

    &-button {
      display: block;
      font-family: inherit;
      font-style: normal;
      font-weight: 500;
      width: 300px;
      height: 46px;
      cursor: pointer;
      border-radius: 23px;
      font-size: 2.4em;
      opacity: 0.99;
      margin: 8px;
      padding-bottom: 0px;
      border: none;
    }

    &-back {
      color: var(--blue-color);
      background-color: var(--white-color);
      text-decoration: none;
    }

    &-subtitle {
      font-size: 1.8em;
      font-weight: 500;
      color: var(--text-color-1);
      padding: 0px;
      width: 400px;
      display: inline-block;
      padding-bottom: 30px;

      @media (max-width: 536px) {
        align-items: center;
        width: 320px;
      }
    }

    &-error-container {
      display: flex;
      justify-content: center;
      padding: 0px 40px;
    }

    &-error {
      font-size: 1.4em;
      color: var(--input-error-color);
    }

    &-error-img {
      padding: 0px 10px;
    }

    &-success {
      font-size: 1.8em;
      font-weight: 500;
      color: var(--success-color);
    }

    &-container {
      display: flex;
      padding-left: 80px;
      padding-right: 100px;
      align-items: center;
    }

    &-fail {
      width: 25px;
      height: 25px;
      padding: 6px;
    }

    &-link {
      font-family: var(--font-family-alt);
    }

    &-change {
      &-message {
        padding-top: 20px;
      }
      &-button {
        padding: 20px 0px 30px;
      }
    }
  }
`;

export default LoginWrapper;
